import { lazy, Suspense, useId, useRef, useState, type ReactNode } from 'react'
import { Info } from 'lucide-react'
import { ChunkBoundary } from '../../app/components/ChunkBoundary'
import './info.css'

const InfoPopover = lazy(() => import('./InfoPopover'))

export function InfoDisclosure({ label, children }: { label: string; children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const anchor = useRef<HTMLButtonElement>(null)
  const id = useId()
  return <>
    <button ref={anchor} className="v5-info-trigger" type="button" aria-label={label} aria-haspopup="dialog" aria-expanded={open} aria-controls={open ? id : undefined} onClick={() => setOpen(!open)}><Info aria-hidden="true" /></button>
    {open && <ChunkBoundary fallback={<span className="v5-info-fallback" role="status">Details need a connection. Try reopening the forecast.</span>}><Suspense fallback={<span className="v5-chrome-sr" role="status">Opening details</span>}><InfoPopover id={id} label={label} anchor={anchor} onOpenChange={setOpen}>{children}</InfoPopover></Suspense></ChunkBoundary>}
  </>
}
